export const BASE_URL = process.env.REACT_APP_API_PATH
export const API_ENTRYPOINT = process.env.REACT_APP_API_ENTRYPOINT
